import { render, staticRenderFns } from "./ContactReceived.vue?vue&type=template&id=3a7be06a&scoped=true&"
import script from "./ContactReceived.vue?vue&type=script&lang=js&"
export * from "./ContactReceived.vue?vue&type=script&lang=js&"
import style0 from "./ContactReceived.vue?vue&type=style&index=0&id=3a7be06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7be06a",
  null
  
)

export default component.exports